import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'

//@ts-expect-error
const LicensesPanel = React.lazy(() => import('orgSettings/licenses-panel'))

export function Bridge() {
  return (
    <RemoteComponent>
      <LicensesPanel />
    </RemoteComponent>
  )
}

export const reactMfeLicensesPanel = createNgReactBridgeDirective(
  'reactMfeLicensesPanel',
  [],
  Bridge,
  []
)
